import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import {
  DsAccordionComponent,
  DsButtonV2Component,
  DsCardComponent,
  DsIconButtonV2Component,
  DsIconComponent,
  DsInlineAlertComponent,
  DsTabsComponent,
  DsTagPillComponent,
} from '@customdesignsystem';

import { APV_ROUTES } from './apv.routes';
import {
  DownloadSvgComponent,
  LoadingArrowComponent,
  CheckComponent,
  ChevronBackComponent,
  ChevronNextComponent,
  LeftArrowComponent,
  InformationComponent,
  RightArrowComponent,
  CurrencyPesoComponent,
} from './core/assets/icons/svg';
import { InformationModalComponent } from './core/assets/icons/svg/information-modal/information-modal.component';

import { RegimeModalComponent } from './subscription/components/regime-modal/regime-modal.component';
import { MultiFundsModalComponent } from './subscription/components/multi-funds-modal/multi-funds-modal.component';
import { GenerationalFundsModalComponent } from './subscription/components/generational-funds-modal/generational-funds-modal.component';
import { OutlineInputComponent } from './core/components/outline-input/outline-input.component';

import { SuccessPage } from './subscription/pages/success/success.page';
import { HomePage } from './home/pages/home/home.page';
import { ErrorStateComponent } from './subscription/components/error-state/error-state.component';
import { BreadcrumbComponent } from './subscription/components/breadcrumb/breadcrumb.component';
import { FailedPage } from './subscription/pages/failed/failed.page';
import { AccountDetailComponent } from './pages/account-detail/account-detail.component';
import { ModifyAmountModalComponent } from './pages/account-detail/modify-amount/modify-amount.component';
import { ConfirmationModalComponent } from './pages/account-detail/confirmation-modal/confirmation-modal.component';
import { SubscriptionCardComponent } from './pages/account-detail/subscription-card/subscription-card.component';
import { SuccessfulMoficationComponent } from './pages/successful-modification/successful-modifcation.component';
import { StopSubscrModalComponent } from './pages/account-detail/stop-subscr-modal/stop-subscr-modal.component';
import { SuccessfulStopSubscriptionComponent } from './pages/successful-stop-subscription/successful-stop-subscription.component';
import { OptionModifyModalComponent } from './pages/account-detail/option-modify-modal/option-modify-modal.component';
import { ModifyRegimenComponent } from './pages/account-detail/modify-regimen/modify-regimen.component';
import { SuccessfulRegimenModificationComponent } from './pages/successful-regimen-modification/successful-regimen-modification.component';
import { DownloadMessageComponent } from './core/components/download-message/download-message.component';
import { BackButtonComponent } from './core/components/back-button/back-button.component';
import { RadioSkeletonComponent } from './core/components/skeletons/radio/radio-skeleton.component';
@NgModule({
  imports: [
    CommonModule,
    CdkStepperModule,
    RouterModule.forChild(APV_ROUTES),
    IonicModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    ChevronBackComponent,
    CheckComponent,
    InformationModalComponent,
    DownloadSvgComponent,
    LoadingArrowComponent,
    ChevronNextComponent,
    LeftArrowComponent,
    RadioSkeletonComponent,
    InformationComponent,
    RightArrowComponent,
    CurrencyPesoComponent,
    OutlineInputComponent,
    DsAccordionComponent,
    DsButtonV2Component,
    DsCardComponent,
    DsIconButtonV2Component,
    DsIconComponent,
    DsInlineAlertComponent,
    DsTabsComponent,
    DsTagPillComponent,
    ErrorStateComponent,
    BreadcrumbComponent,
  ],
  declarations: [
    HomePage,
    SuccessPage,
    GenerationalFundsModalComponent,
    RegimeModalComponent,
    MultiFundsModalComponent,
    FailedPage,
    AccountDetailComponent,
    ModifyAmountModalComponent,
    ConfirmationModalComponent,
    SubscriptionCardComponent,
    SuccessfulMoficationComponent,
    StopSubscrModalComponent,
    SuccessfulStopSubscriptionComponent,
    OptionModifyModalComponent,
    ModifyRegimenComponent,
    SuccessfulRegimenModificationComponent,
    DownloadMessageComponent,
    BackButtonComponent,
  ],
})
export class ApvModule {}
